import React from 'react';
import { FileContext } from './context';

export const useFileController = () => React.useContext(FileContext);
export default useFileController;
